if (!customElements.get('featured-tabs')) {
  class FeaturedTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      else return;

      event.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active);
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel, i) => (panel.hidden = i !== index));
    }
  }

  customElements.define('featured-tabs', FeaturedTabs);
}
